import React from 'react'
import DetailGrid from '../components/DetailGrid'
import QuoteBlock from '../Introduction/QuoteBlock'
import Solutions from './Solutions'
import { useRecoilState } from 'recoil'
import { detailedResultState } from '../../../utils/recoil'
import { useTranslation } from 'react-i18next'

const Strength = () => {
  const [data] = useRecoilState(detailedResultState);
  const { t } = useTranslation("result");
  return (
    <div>
        <DetailGrid number={"1"} title={t("grid4")} data={data?.strengths} /> 
        <QuoteBlock text={data?.quote}/>
        <DetailGrid number={"2"} title={t("grid5")} data={data?.challenges} />
        <Solutions />
        <QuoteBlock text={data?.closing_tip} />
    </div>
  )
}

export default Strength